import CustomImage from '../../fragments/custom-image/CustomImage';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import AnimateSplitLines from '../../fragments/split-text/AnimateSplitLines';

import { useRef, useState } from 'react';
import { useIsDesktop } from '../../context/ThemeContextManagement';

import { useCustomScroll } from '../../utils/useCustomScroll';

import { motion, useTransform } from 'motion/react';

export default function Hero({ block, index }) {
  const isDesktop = useIsDesktop();

  const HeadingTag = index === 0 ? 'h1' : 'h2';
  const [isMultiLine, setIsMultiLine] = useState(false);

  const containerRef = useRef(null);

  const { scrollYProgress } = useCustomScroll({
    enabled: index === 0,
    target: containerRef,
    offset: ['start start', 'end start'],
  });

  const yOffset = useTransform(
    scrollYProgress,
    [0, 1],
    [0, isDesktop ? 250 : 100]
  );

  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0, 0.6]);

  // Map the yOffset to a transform string
  const transform = useTransform(
    yOffset,
    (value) => `translateY(${value}px) translateZ(0)`
  );

  if (!block) return null;

  return (
    <ComponentWrapper
      block={block}
      className={`Hero`}
      ref={containerRef}
      scrollTrigger
    >
      <motion.div
        className={'Hero-darkOverlay'}
        style={{
          opacity: overlayOpacity,
        }}
      />
      <motion.div
        className={'l-grid'}
        style={{
          willChange: 'transform',
          transform: index == 0 ? transform : 'none',
        }}
      >
        <div className="l-grid__col l-grid__col--l-6-12 ">
          <div className={`Hero-content`}>
            {block.heading && (
              <HeadingTag className={'Hero-heading h1'}>
                <AnimateSplitLines
                  html={block.heading}
                  index={index}
                  deferToParent
                  onSplit={(split) => setIsMultiLine(split.lines.length > 1)}
                />
              </HeadingTag>
            )}
            {block.description && (
              <p className="Hero-description ">
                <AnimateSplitLines
                  html={block.description}
                  index={index}
                  animationOrder={1}
                  deferToParent
                />
              </p>
            )}
          </div>
        </div>
        <div className="l-grid__col l-grid__col--l-4-12 l-grid__col--xs-push-5-12 l-grid__col--l-push-2-12">
          {block.image && (
            <div
              className="Hero-media"
              style={{
                '--variable-space': `calc(var(--step-8) * ${isMultiLine ? '1' : '0'}.33)`,
              }}
            >
              <CustomImage
                image={block.image}
                fill={true}
                forceLoad={index === 0}
                fetchPriority={index === 0 ? 'high' : undefined}
                parallax
                reveal
                desktopWidth={33}
                index={index}
                animationOrder={3}
              />
            </div>
          )}
        </div>
      </motion.div>
    </ComponentWrapper>
  );
}
